module.exports = __webpack_public_path__ + "static/media/warranty_3.4a8dfadb.pdf";